/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export default function parseJson(json: any, errorMessage = '', defaultReturn: any = []) {
  if (typeof json === 'string') {
    try {
      return JSON.parse(json);
    } catch {
      console.error(`Error parsing JSON! ${errorMessage || 'Please provide valid JSON object'}`);

      return defaultReturn;
    }
  }
  return json || defaultReturn;
}
